// Group the merchant and bank description without changing the underlying transaction.
const MerchantTransactionCell = ({ transaction, t }) => {
  const merchant = transaction.merchant_name;
  const name = transaction.name;
  return (
    <div className='merchant-transaction-cell'>
      <div className='merchant-transaction-cell__primary' title={merchant || name}>{merchant || name || '—'}</div>
      <div className='merchant-transaction-cell__secondary' title={merchant ? name : undefined}>
        {merchant ? name : t.read('cc_transactions.merchant_not_provided')}
      </div>
    </div>
  );
};

export default MerchantTransactionCell;
